import { TaskFilterOptions, Timestamp } from '@griply/types';

// tasksOnly is deliberate: completed habits/repeating are not painted on calendars.
export const getCompletedTasksInRangeFilterOptions = (
  start: Timestamp,
  end: Timestamp,
): TaskFilterOptions[] => [
  {
    showCompleted: true,
    completedStartDate: start,
    completedEndDate: end,
    tasksOnly: true,
  },
];
